// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RecentProposalFragment = { __typename?: 'Proposal', id: string, displayName: string, giftingProposal?: { __typename?: 'GiftingProposal', id: string } | null, household: { __typename?: 'Household', id: string, displayName: string }, crtProposal?: { __typename?: 'CRTProposal', id: string } | null, cltProposal?: { __typename?: 'CLTProposal', id: string } | null };

export type RecentClientFragment = { __typename?: 'Household', id: string, displayName: string };

export type RecentEntityFragment = { __typename?: 'Entity', id: string, kind: Types.EntityKind, stage: Types.EntityStage, household: { __typename?: 'Household', id: string, displayName: string }, subtype: { __typename: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename: 'CLTTrust', id: string, displayName: string } | { __typename: 'CRTTrust', id: string, displayName: string } | { __typename: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename: 'DonorAdvisedFund', id: string, displayName: string } | { __typename: 'GPBusinessEntity', id: string, displayName: string } | { __typename: 'GRATTrust', id: string, displayName: string } | { __typename: 'ILITTrust', id: string, displayName: string } | { __typename: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename: 'IrrevocableTrust', id: string, displayName: string } | { __typename: 'JointPersonalAccount', id: string, displayName: string } | { __typename: 'LLCBusinessEntity', id: string, displayName: string } | { __typename: 'LPBusinessEntity', id: string, displayName: string } | { __typename: 'PrivateFoundation', id: string, displayName: string } | { __typename: 'QPRTTrust', id: string, displayName: string } | { __typename: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename: 'RevocableTrust', id: string, displayName: string } | { __typename: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename: 'SLATTrust', id: string, displayName: string } | { __typename: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } };

export type RecentEntitiesQueryVariables = Types.Exact<{
  householdId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  first: Types.Scalars['Int']['input'];
}>;


export type RecentEntitiesQuery = { __typename?: 'Query', recentProposals: Array<(
    { __typename?: 'Proposal' }
    & RecentProposalFragment
  )>, recentClients: Array<(
    { __typename?: 'Household' }
    & RecentClientFragment
  )>, recentEntities: Array<(
    { __typename?: 'Entity' }
    & RecentEntityFragment
  )> };

export const Operations = {
  Query: {
    RecentEntities: 'RecentEntities' as const
  },
  Fragment: {
    RecentProposal: 'RecentProposal' as const,
    RecentClient: 'RecentClient' as const,
    RecentEntity: 'RecentEntity' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const RecentProposalFragmentDoc = gql`
    fragment RecentProposal on Proposal {
  id
  displayName
  giftingProposal {
    id
  }
  household {
    id
    displayName
  }
  crtProposal {
    id
  }
  cltProposal {
    id
  }
}
    `;
export const RecentClientFragmentDoc = gql`
    fragment RecentClient on Household {
  id
  displayName
}
    `;
export const RecentEntityFragmentDoc = gql`
    fragment RecentEntity on Entity {
  id
  kind
  stage
  household {
    id
    displayName
  }
  subtype {
    __typename
    id
    displayName
  }
}
    `;
export const RecentEntitiesDocument = gql`
    query RecentEntities($householdId: ID, $first: Int!) {
  recentProposals(first: $first, where: {clientID: $householdId}) {
    ...RecentProposal
  }
  recentClients(first: $first) {
    ...RecentClient
  }
  recentEntities(first: $first, where: {clientID: $householdId}) {
    ...RecentEntity
  }
}
    ${RecentProposalFragmentDoc}
${RecentClientFragmentDoc}
${RecentEntityFragmentDoc}`;

/**
 * __useRecentEntitiesQuery__
 *
 * To run a query within a React component, call `useRecentEntitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentEntitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentEntitiesQuery({
 *   variables: {
 *      householdId: // value for 'householdId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useRecentEntitiesQuery(baseOptions: Apollo.QueryHookOptions<RecentEntitiesQuery, RecentEntitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentEntitiesQuery, RecentEntitiesQueryVariables>(RecentEntitiesDocument, withFetchPolicyContext(options));
      }
export function useRecentEntitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentEntitiesQuery, RecentEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentEntitiesQuery, RecentEntitiesQueryVariables>(RecentEntitiesDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useRecentEntitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RecentEntitiesQuery, RecentEntitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecentEntitiesQuery, RecentEntitiesQueryVariables>(RecentEntitiesDocument, withFetchPolicyContext(options));
        }
export type RecentEntitiesQueryHookResult = ReturnType<typeof useRecentEntitiesQuery>;
export type RecentEntitiesLazyQueryHookResult = ReturnType<typeof useRecentEntitiesLazyQuery>;
export type RecentEntitiesSuspenseQueryHookResult = ReturnType<typeof useRecentEntitiesSuspenseQuery>;
export type RecentEntitiesQueryResult = Apollo.QueryResult<RecentEntitiesQuery, RecentEntitiesQueryVariables>;